import React, { useState, useEffect, useMemo } from "react"

import Rem_filter_page from "../layout/header";
import axios from "axios";
import ReviewSecondSection from "./reviewSecondSection";
import { useTranslation } from "react-i18next";
import i18next from "i18next";



function ReviewFirstsection(props) {
	const { t, i18n } = useTranslation('common');

	useEffect(() => {
		jQuery(".continue_btn").click(function(){
			event.preventDefault();
			jQuery("html, body").animate({scrollTop:0},600);
			});
		if (props?.lan == 'en') {
			i18next.changeLanguage("en");
		} else {
			i18next.changeLanguage("el");
		}
	}, [])
	const lan = props?.lan;
	const site_url = props?.site_url;
	const post_id = props?.trader;
	const post_title = props?.post_title;

	const [buttonValue1, setbuttonValue] = useState('');
	const [buttonValue2, setbuttonValue2] = useState('');
	const handleInput = e => {
		const buttonValue = e.target.value;
		if (buttonValue == 'Yes') {
			jQuery(e.target).hasClass('rem_yes_btn');
			jQuery(e.target).parent().find('button').addClass("yes_btn1_click");
			jQuery(e.target).parent().parent().find('button')[1].classList.remove("yes_btn1_click");
		}
		if (buttonValue == 'No') {
			jQuery(e.target).hasClass('rem_no_btn');
			jQuery(e.target).parent().find('button').addClass('yes_btn1_click');
			jQuery(e.target).parent().parent().find('button')[0].classList.remove("yes_btn1_click");
		}
		setbuttonValue(buttonValue);
	};
	const handleInput2 = e => {
		if (e.target.value == 'Yes') {
			console.log(jQuery(e.target).hasClass('rem_yes_btn2'));
			jQuery(e.target).hasClass('rem_yes_btn2');
			jQuery(e.target).parent().find('button').addClass("yes_btn1_click");
			jQuery(e.target).parent().parent().find('button')[1].classList.remove("yes_btn1_click");
		}
		if (e.target.value == 'No') {
			jQuery(e.target).hasClass('rem_no_btn2');
			jQuery(e.target).parent().find('button').addClass('yes_btn1_click');
			jQuery(e.target).parent().parent().find('button')[0].classList.remove("yes_btn1_click");
		}
		setbuttonValue2(e.target.value);

	};

	const [rating1, setrating1] = useState('');
	const [rating2, setrating2] = useState('');
	const [rating3, setrating3] = useState('');
	const [rating4, setrating4] = useState('');
	const [rating5, setrating5] = useState('');
	const [rating6, setrating6] = useState('');
	const [user_message, setuser_message] = useState('');
	const [isShown, setIsShown] = useState(false);
	const [submitted, setSubmitted] = useState(false);
	const handleChange = event => {
		const name = event.target.getAttribute('name');
		switch (name) {
			case 'rating1':
				setrating1(event.target.value);
				break;
			case 'rating2':
				setrating2(event.target.value);
				break;
			case 'rating3':
				setrating3(event.target.value);
				break;
			case 'rating4':
				setrating4(event.target.value);
				break;
			case 'rating5':
				setrating5(event.target.value);
				break;
			case 'rating6':
				setrating6(event.target.value);
				break;
			case 'user_message':
				setuser_message(event.target.value);
				break;
		}

	};

	const handleClick = event => {
	
		event.preventDefault();
		// submitted = true;

		setSubmitted(true)

		if (rating1 && rating2 && rating3 && rating4 && rating5 && rating6 && post_id && buttonValue1 && buttonValue2 && user_message) {
			const url = props?.site_url + '/review-2';
			//window.location.href = url;
			if (props?.lan == 'en') {
				window.history.replaceState("object or string", "Title", "/review-section-2");
			}
			else {
				window.history.replaceState("object or string", "Title", "/review-2");
			}

			setIsShown(current => !current);
			window.scrollTo({
				top: 0,
				smooth: true,
			  });
		}


	};


	return (
		<div>
			<div id="recaptcha"></div>

			{
				(isShown == true) ?
					<div>{isShown && < ReviewSecondSection rating1={rating1} rating2={rating2} rating3={rating3} rating4={rating4} rating5={rating5} rating6={rating6} user_message={user_message} btn1={buttonValue1} btn2={buttonValue2} post_id={post_id} site_url={site_url} lan={lan}></ReviewSecondSection>}</div>

					:
					<div class="review_body">
						<section class="main_review_section">
							<div class="container_review_main text-center">
								<div class="row">
									<div class="main_review_box">


										{
											(post_title) ?
												<h2>{t('You are leaving a review for ')}<b>{(post_title) ? post_title : ''}</b></h2>
												: ''
										}
									</div>
								</div>
							</div>
						</section>


						<section class="mt-4">
							<div class="container_review_main">
								<div class="row">
									<div class="col-12 did_you_see">
										<h2 class="mb-3">{t('Did you find this trader on tamastoria.gr?')}</h2>
									</div>

									<div class="yes_no_btn mt-3 d-flex col-12">
										<div class="yes_btn">
											<button value="Yes" class="rem_yes_btn" onClick={handleInput}>{t('Yes')}</button>
										</div>
										<div class="no_btn">
											<button value="No" class="rem_yes_no_btn" onClick={handleInput}>{t('No')}</button>
										</div>

									</div>
									{(buttonValue1 == '' && submitted) ? <p className="ratingFormValidation">{t('Required')}</p> :
										<p></p>}
								</div>
							</div>
						</section>
						<section class="mt-5 review_all_main-section">
							<div class="container_review_main">
								<div class="row">
									<div class="col-xl-6 col-lg-6 col-md-6">
										<div class="review_details_leave">
											<h2>{t('Initial Impression')}</h2>
											<p>{t('Was the trader polite and helpful at first contact? Did they understand your work requirements and clearly explain their plans?')}</p>

											<div class="review-form-star-rating">
												<input type="radio" id="c1-5-stars" name="rating1" onChange={handleChange}
													value="5" />
												<label for="c1-5-stars" class="star">
													<font>
														<font>★</font>
													</font>
												</label>
												<input type="radio" id="c1-4-stars" name="rating1" onChange={handleChange} value="4" />
												<label for="c1-4-stars" class="star">
													<font>
														<font>★</font>
													</font>
												</label>
												<input type="radio" id="c1-3-stars" name="rating1" onChange={handleChange} value="3" />
												<label for="c1-3-stars" class="star">
													<font>★</font>
												</label>
												<input type="radio" id="c1-2-stars" name="rating1" onChange={handleChange} value="2" />
												<label for="c1-2-stars" class="star">
													<font>★</font>
												</label>
												<input type="radio" id="c1-1-star" name="rating1" onChange={handleChange} value="1" />
												<label for="c1-1-star" class="star">
													<font>★</font>
												</label>
											</div>
											{(rating1 == '' && submitted) ? <p className="ratingFormValidation">{t('Required')}</p> :
												<p></p>}
										</div>



									</div>


									<div class="col-xl-6 col-lg-6 col-md-6">
										<div class="review_details_leave">
											<h2>{t('Punctuality')}</h2>
											<p>{t('Did the trader arrive on time, on every day that they were carrying out work for you? Were any breaks a reasonable length of time?')}</p>

											<div class="review-form-star-rating">
												<input type="radio" id="c2-5-stars" name="rating2" onChange={handleChange} value="5" />
												<label for="c2-5-stars" class="star">
													<font>
														<font>★</font>
													</font>
												</label>
												<input type="radio" id="c2-4-stars" name="rating2" onChange={handleChange} value="4" />
												<label for="c2-4-stars" class="star">
													<font>
														<font>★</font>
													</font>
												</label>
												<input type="radio" id="c2-3-stars" name="rating2" onChange={handleChange} value="3" />
												<label for="c2-3-stars" class="star">
													<font>★</font>
												</label>
												<input type="radio" id="c2-2-stars" name="rating2" onChange={handleChange} value="2" />
												<label for="c2-2-stars" class="star">
													<font>★</font>
												</label>
												<input type="radio" id="c2-1-star" name="rating2" onChange={handleChange} value="1" />
												<label for="c2-1-star" class="star">
													<font>★</font>
												</label>
											</div>
										</div>
										{(rating2 == '' && submitted) ? <p className="ratingFormValidation">{t('Required')}</p> :
											<p></p>}
									</div>
								</div>

								<div class="row mt-4">
									<div class="col-xl-6 col-lg-6 col-md-6">
										<div class="review_details_leave">
											<h2>{t('Cleanliness')}</h2>
											<p>{t('Was work done with care, to minimise dust, dirt, and any damage to your property? Was any mess cleared up properly after?')}</p>

											<div class="review-form-star-rating">
												<input type="radio" id="c3-5-stars" name="rating3" onChange={handleChange} value="5" />
												<label for="c3-5-stars" class="star">
													<font>
														<font>★</font>
													</font>
												</label>
												<input type="radio" id="c3-4-stars" name="rating3" onChange={handleChange} value="4" />
												<label for="c3-4-stars" class="star">
													<font>
														<font>★</font>
													</font>
												</label>
												<input type="radio" id="c3-3-stars" name="rating3" onChange={handleChange} value="3" />
												<label for="c3-3-stars" class="star">
													<font>★</font>
												</label>
												<input type="radio" id="c3-2-stars" name="rating3" onChange={handleChange} value="2" />
												<label for="c3-2-stars" class="star">
													<font>★</font>
												</label>
												<input type="radio" id="c3-1-star" name="rating3" onChange={handleChange} value="1" />
												<label for="c3-1-star" class="star">
													<font>★</font>
												</label>
											</div>
											{(rating3 == '' && submitted) ? <p className="ratingFormValidation">{t('Required')}</p> :
												<p></p>}
										</div>
									</div>
									<div class="col-xl-6 col-lg-6 col-md-6">
										<div class="review_details_leave">
											<h2>{t('Quality')}</h2>
											<p>{t('Were you happy with the standard of work? Was every aspect of the job given enough attention and finished to your expectations?')}</p>

											<div class="review-form-star-rating">
												<input type="radio" id="c4-5-stars" name="rating4" onChange={handleChange} value="5" />
												<label for="c4-5-stars" class="star">
													<font>
														<font>★</font>
													</font>
												</label>
												<input type="radio" id="c4-4-stars" name="rating4" onChange={handleChange} value="4" />
												<label for="c4-4-stars" class="star">
													<font>
														<font>★</font>
													</font>
												</label>
												<input type="radio" id="c4-3-stars" name="rating4" onChange={handleChange} value="3" />
												<label for="c4-3-stars" class="star">
													<font>★</font>
												</label>
												<input type="radio" id="c4-2-stars" name="rating4" onChange={handleChange} value="2" />
												<label for="c4-2-stars" class="star">
													<font>★</font>
												</label>
												<input type="radio" id="c4-1-star" name="rating4" onChange={handleChange} value="1" />
												<label for="c4-1-star" class="star">
													<font>★</font>
												</label>
											</div>
										</div>
										{(rating4 == '' && submitted) ? <p className="ratingFormValidation">{t('Required')}</p> :
											<p></p>}
									</div>
								</div>


								<div class="row mt-4">
									<div class="col-xl-6 col-lg-6 col-md-6">
										<div class="review_details_leave">
											<h2>{t('Value')}</h2>
											<p>{t('Did you feel the completed work was good value for the agreed cost? Were any products purchased by the trader appropriate in cost?')}</p>

											<div class="review-form-star-rating">
												<input type="radio" id="c5-5-stars" name="rating5" onChange={handleChange} value="5" />
												<label for="c5-5-stars" class="star">
													<font>
														<font>★</font>
													</font>
												</label>
												<input type="radio" id="c5-4-stars" name="rating5" onChange={handleChange} value="4" />
												<label for="c5-4-stars" class="star">
													<font>
														<font>★</font>
													</font>
												</label>
												<input type="radio" id="c5-3-stars" name="rating5" onChange={handleChange} value="3" />
												<label for="c5-3-stars" class="star">
													<font>★</font>
												</label>
												<input type="radio" id="c5-2-stars" name="rating5" onChange={handleChange} value="2" />
												<label for="c5-2-stars" class="star">
													<font>★</font>
												</label>
												<input type="radio" id="c5-1-star" name="rating5" onChange={handleChange} value="1" />
												<label for="c5-1-star" class="star">
													<font>★</font>
												</label>
											</div>
											{(rating5 == '' && submitted) ? <p className="ratingFormValidation">{t('Required')}</p> :
												<p></p>}
										</div>
									</div>
									<div class="col-xl-6 col-lg-6 col-md-6">
										<div class="review_details_leave">
											<h2>{t('Overall rating')}</h2>
											<p>{t('Did the finished work meet or exceed your expectations or were you disappointed? Rate your level of satisfaction as a whole.')}</p>

											<div class="review-form-star-rating">
												<input type="radio" id="c6-5-stars" name="rating6" onChange={handleChange} value="5" />
												<label for="c6-5-stars" class="star">
													<font>
														<font>★</font>
													</font>
												</label>
												<input type="radio" id="c6-4-stars" name="rating6" onChange={handleChange} value="4" />
												<label for="c6-4-stars" class="star">
													<font>
														<font>★</font>
													</font>
												</label>
												<input type="radio" id="c6-3-stars" name="rating6" onChange={handleChange} value="3" />
												<label for="c6-3-stars" class="star">
													<font>★</font>
												</label>
												<input type="radio" id="c6-2-stars" name="rating6" onChange={handleChange} value="2" />
												<label for="c6-2-stars" class="star">
													<font>★</font>
												</label>
												<input type="radio" id="c6-1-star" name="rating6" onChange={handleChange} value="1" />
												<label for="c6-1-star" class="star">
													<font>★</font>
												</label>
											</div>
										</div>
										{(rating6 == '' && submitted) ? <p className="ratingFormValidation">{t('Required')}</p> :
											<p></p>}
									</div>
								</div>
							</div>
						</section>

						<section class="mt-5">
							<div class="container_review_main">
								<div class="row">
									<div class="col-12 did_you_see">
										<h2>{t('Would you recommend this trader to a friend?')}</h2>
									</div>

									<div class="yes_no_btn mt-3 d-flex col-12">
										<div class="yes_btn">
											<button value="Yes" class="rem_yes_btn2" onClick={handleInput2}>{t('Yes')}</button>
										</div>
										<div class="no_btn">
											<button value="No" class="rem_no_btn2" onClick={handleInput2}>{t('No')}</button>
										</div>

									</div>
									{(buttonValue2 == '' && submitted) ? <p className="ratingFormValidation">{t('Required')}</p> :
										<p></p>}
									<form class="comments_review">
										<textarea rows="9" name="user_message" onChange={handleChange} placeholder={t('Comments')}></textarea>
										{(user_message == '' && submitted) ? <p className="ratingFormValidation">{t('Required')}</p> :
											<p></p>}
									</form>

									<div class="review_footer_paira">
										<p>{t('Anything else to say? You can add relevant details about how the trader performed on your job, in addition to the ratings above. Perhaps you want to give criticism or praise to a specific aspect of the work? Your comments above will be ')}<b>{t('quoted on the website')}</b>{t(' alongside your review.')}</p>
									</div>

									<div class="continue_btn" >

										<a href="#" onClick={handleClick}>{t('Continue')}</a>
									</div>
								</div>

							</div>
						</section>
					</div>
			}

		</div>);



}
export default ReviewFirstsection;
